import React from "react";
import "./Components/App.css";
import WhatsappLogo from './images/whatsapp-icon.png';
import InstagramLogo from './images/insta-icon.png';
import TiktokLogo from './images/tiktok-icon.png';
import GymHouseLogo from './images/gymHouse-logo.png';
import GoogleMapsLogo from './images/GoogleMaps-icon.png';
import PhysioPhoto from './images/Team/PhysioApplyPhoto.png'

import coachesGenPic from './images/Team/FitnessInstructor.jpeg'
import { useNavigate } from "react-router-dom";

export default function Home()  {    
  const navigate = useNavigate();
    return (      
      
            <div className="default-page">
              
            <img alt="Welcome to GymHouse"  src={GymHouseLogo}></img>
              <h1><b>Welcome To Our House</b></h1>
              <div className="spacer"></div>
              <div className="spacer"/>
              <h2><b>Meet us!</b></h2>
              <div className="spacer"/>
              <div className="spacer"/>
              <hr/>
              <div className="spacer"/>
              <h3>What do we do?</h3>
              <div className="spacer"/>
              <li>We are a community doing our best to deliver all kinds of health and fitness services.</li>
              <li>We make your life easier to find your way to a healthy lifestyle.</li>
              <hr/>
                <div className="spacer"/>
                <h3 >How do we do it?</h3>
                <div className="spacer"/>
                <li>We connect coaches, physio, nutritionists, life coaches, psychotherapists together so you can come as you are, and we guide you throughout your journey</li>
                <li>We provide coaches for one-on-one training sessions if you are a client</li>
                <li>We provide clients for one-on-one sessions if you are a coach</li>
                <li>We provide physio sessions</li>
                <li>We provide nutritionist sessions</li>
                <hr/>
                <div className="spacer"/>
                <h3>Why do we do it?</h3>
                <div className="spacer"/>
                <li>Our mission is to share the fitness culture and to do our best to improve the quality of life and we hope worldwide</li>
                <div className="spacer"/>
                 <hr/>
                <div className="meet-us-container">
                {/* <li><img onClick={()=>{                 
                  navigate('/TheHouse')}} alt="Meet our founder" className="photos" src={marioPhoto}></img><p>The House</p></li> */}
                <li><img onClick={()=>{                 
                  navigate('/Coaches')}} alt="Meet our founder"className="photos" src={coachesGenPic}></img><p>Coaches</p></li>        
                 <li><img onClick={()=>{                 
                  navigate('/Physiotherapists')}} alt="Meet our founder" className="photos" src={PhysioPhoto}></img><p>Physiotherapists</p></li>
                {/* <li><img onClick={()=>{                 
                  navigate('/Nutritionists')}} alt="Meet our founder" className="photos" src={marioPhoto}></img><p>Nutritionists</p></li> */}
                {/* <li><img onClick={()=>{                 
                  navigate('/Classes')}} alt="Meet our founder" className="photos" src={marioPhoto}></img><p>Classes</p></li>  */}
                 {/* <li><img alt="Meet our founder" className="photos" src={marioPhoto}></img>Other</li>  */}
                </div>
                <hr/>
                <div className="spacer"/>
                <h2><b>Join us!</b></h2>
                <div className="spacer"/>
                <h3>It will be our pleasure to meet you and help you reach your goals if:</h3>
                <li>You need a personal fitness coach</li>
                <li>You need a nutritionist</li>
                <li>You need a sports and injuries doctor</li>
                <li>You need a physiotherapist</li>
                <li>You need a psychotherapist</li>
                <li>You need a life Coach</li>
                <li>You need a group training session</li>
                <li>You don't know what you need to be fit</li>
                <div className="spacer"/>
                <hr/>
                <h2><b>How to find us?</b></h2>
                <div className="icons-container">
                  <div></div>
                <li><a target="blank" href="https://wa.me/+96171453095" ><img alt="Reach us on Whatsapp" className="icons" src={WhatsappLogo}></img></a></li>
                <li><a target="blank" href="https://www.instagram.com/gymhouse_lb?igsh=MWpsaGZzOXppM3I5Zg%3D%3D&utm_source=qr"><img alt="Reach us on Instagram" className="icons" src={InstagramLogo}></img></a> </li>
                <li><a target="blank" href="https://www.tiktok.com/@gymhouse_lb?_t=8j1PECEQvuE&_r=1"><img alt="Reach us on Tiktok" className="icons" src={TiktokLogo}></img></a> </li>
                <li><a target="blank" href="https://maps.app.goo.gl/JEc6kySrX7HA9N1S8 " ><img alt="Find us on GoogleMaps" className="icons" src={GoogleMapsLogo}></img></a></li>
                <div></div>
               </div>
                <hr/>
              </div> 
    );
  }

